module.exports = __webpack_public_path__ + "img/23.06ad4ea4.jpg";